module.exports = __webpack_public_path__ + "img/icons_9.3d2ec175.png";